import * as React from "react"

import bem from "../../../bem"

import "./ProgressBar.scss"

const b = bem.with("NewUI__progressBar")

export type ProgressBarColor = "green" | "gold" | "red" | "orange"

interface Props {
    className?: string
    color?: ProgressBarColor
    value?: number
}

export default class ProgressBar extends React.Component<Props> {
    render(): JSX.Element {
        const { className, color = "gold", value = 100 } = this.props
        return (
            <span className={b() + (className || "")}>
                <div
                    className={b("fluid", { color })}
                    style={{ width: `${value}%` }}
                />
            </span>
        )
    }
}

export type IProgressBar = typeof ProgressBar
